import { TextField } from '@eta/components';
import { Spinner, SpinnerSize } from '@fluentui/react';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Defaults } from '../../common/config/constants';
import './VerifyCompleteProfileOTP.scss';

export interface VerifyCompleteProfileOTPProps {
    setotpValue: (value: string) => void;
    resendOTP: () => void;
    InvalidOTP: boolean;
    MobileNo: string | undefined;
    resendOTPInProgress?: boolean;
}
const VerifyCompleteProfileOTP: FC<VerifyCompleteProfileOTPProps> = (
    props: VerifyCompleteProfileOTPProps
) => {

    const { setotpValue, InvalidOTP, MobileNo, resendOTP, resendOTPInProgress } = props;
    const [otpCode, setotpCode] = useState<string[]>([]);
    const { t } = useTranslation(['VerifyOTP']);
    const regexp = /^[0-9\b]+$/;
    const [seconds, setSeconds] = useState(Defaults.ResendOTP);

    const focusNextField = (nextField: string, index: number) => {
        if (nextField?.slice(0, -1) + index !== null && index <= 5)
            // eslint-disable-next-line no-unused-expressions
            document.getElementById(nextField.slice(0, -1) + index)?.focus();
    };

    const checkvaildnumber = (text: string | undefined) => {
        return text && regexp.test(text.trim());
    };

    const handleonchage = (value: string | undefined, index: number) => {
        const Code = [...otpCode];
        if (checkvaildnumber(value)) {
            Code[index] = value ?? '';
            if (value !== '') {
                focusNextField(`code${index}`, index + 1);
            }
        } else {
            Code[index] = '';
        }
        setotpCode(Code);
        if (Code.join('').length === 6) {
            setotpValue(Code.join(''));
        } else {
            setotpValue('');
        }
    };

    const renderTimer = (time: number) => {
        let second = (time % 60).toString();
        let minute = (Math.floor(time / 60)).toString();
        minute = minute.toString().length === 1 ? `0${minute}` : minute.toString();
        second = second.toString().length === 1 ? `0${second}` : second.toString();
        return `${minute}:${second}`;
    };
    
    useEffect(() => {
        if (seconds > 0) {
            setTimeout(() => setSeconds(seconds - 1), 1000);
        }
    });

    return (
        <div className='verifyCompleteProfileOTP'>
            <div className="header">
                <h2>{t('verify_Mobile')}</h2>
            </div>
            <div className='bodyLine'>
                <div className='verify_OTPMsg'>
                    <span>{t('verify_Msg')}{'    '}
                    <span className='verify_MobileNo'>{'*****'}{MobileNo?.slice(MobileNo.length - 5)}</span>
                    </span>
                </div>
                <div className='verticalSeperator' />
                <div className='content_verifyProfile'>
                    <div className='inner_div'>
                        <p className='otp-enter'>{t('enter_OTP')}</p>
                        <div className={InvalidOTP ? 'otpMsgField otpErrorrmsg' : 'otpMsgField'}>
                            {[...new Array(6)].map((_value, index) => {
                                return (
                                    <TextField
                                        maxLength={1}
                                        autoFocus={index === 0}
                                        onChange={(_, v) => handleonchage(v, index)}
                                        id={`code${index}`}
                                        value={otpCode[index]}
                                    />
                                );
                            })}
                        </div>
                        <br />
                        {InvalidOTP && <p className='invalid_otp'>{t('invalid_OTP')}</p>}
                        <div>
                            <div className='resnd'>
                                <span> {t('receive_SMS')} </span>
                                {seconds > 0 ? (
                                    <div className='inline_Content'>
                                        <span> {t('resend_code')} </span>
                                        <span className='font_Timer'> {renderTimer(seconds)} </span>
                                    </div>

                                ) : (
                                        // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                        <a href={undefined} className='Link_Button'
                                            onClick={() => {
                                                setSeconds(Defaults.ResendOTP);
                                                resendOTP();
                                            }} >
                                            {t('resend')}
                                            {resendOTPInProgress && <Spinner size={SpinnerSize.small}/>}
                                        </a>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default VerifyCompleteProfileOTP;